import { useLykaApi } from '@/services/lyka-api'

interface PostcodeData {
  message: 'Success' | string
  data:
    | []
    | {
        id: number
        postcode: number
        shipping_zone_id: number
        onbaording_status: boolean
        notes?: string
        bab_version_two: boolean
      }
  total?: number
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const useVerifyPostcode = () => {
  const verify = async (postcode: string): Promise<boolean | undefined> => {
    const base = import.meta.env.ASSETS_PREFIX as string | undefined

    if (!base) {
      return undefined
    }

    try {
      const path = `/api/v1/shipping/postcodes?postcode=${postcode}`

      const data: PostcodeData = await useLykaApi().get(path)

      if (data.message === 'Success') {
        return true
      } else {
        return false
      }
    } catch (err) {
      return false
    }
  }

  return {
    verify,
  }
}
